
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 1.5c1.931 0 3.5 1.569 3.5 3.5S9.931 8.5 8 8.5A3.502 3.502 0 014.5 5c0-1.931 1.569-3.5 3.5-3.5M8 10c2.762 0 5-2.237 5-5s-2.238-5-5-5-5 2.237-5 5 2.238 5 5 5m6.5 4.5h-13c0-.669.26-1.297.731-1.769A2.484 2.484 0 014 12c1.284 0 1.281-.034 1.775.131A6.922 6.922 0 008 12.5c.756 0 1.506-.125 2.225-.369.494-.168.49-.131 1.775-.131 1.378 0 2.5 1.122 2.5 2.5m-2.5-4c-1.269 0-1.488-.047-2.256.213a5.455 5.455 0 01-3.488 0c-.768-.26-.984-.213-2.256-.213a4 4 0 00-4 4v.5a1 1 0 001 1h14a1 1 0 001-1v-.5a4 4 0 00-4-4","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    